import { render, staticRenderFns } from "./AddSeguroiparcelamentoPage.vue?vue&type=template&id=0b23fa57"
import script from "./AddSeguroiparcelamentoPage.vue?vue&type=script&lang=js"
export * from "./AddSeguroiparcelamentoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports